"use client";

import { Info } from "lucide-react";

/**
 * Informational note rendered below the Shopify Tools grid. Explains that the
 * Catalog Search and Policies & FAQs tools pull live data from Shopify on
 * every request — users do NOT need to mirror product or policy content into
 * their knowledge base for those tools to work.
 *
 * Also warns about the knowledge-base overlap pitfall: if the KB already
 * contains product/policy content, enabling both sources means the AI sees
 * both simultaneously and can produce conflicting answers.
 */
export function ShopifyLiveDataNote() {
  return (
    <div className="flex gap-2 p-2.5 rounded-md border border-sky-200 bg-sky-50 text-[11px] leading-snug text-sky-900">
      <Info className="w-3.5 h-3.5 text-sky-600 shrink-0 mt-[1px]" />
      <div className="space-y-1">
        <p>
          <span className="font-semibold">Catalog Search</span> <span>and</span>{" "}
          <span className="font-semibold">Policies &amp; FAQs</span> <span>fetch live
          data from your Shopify store on every request — you don&apos;t need
          to mirror product or policy info in your knowledge base for these
          tools to work.</span>
        </p>
        <p className="text-sky-800">
          <span className="font-semibold">Heads up:</span> <span>if your knowledge
          base already contains product or policy content, the AI will see
          both sources at once and may give conflicting answers. Consider
          removing duplicated entries from the knowledge base.</span>
        </p>
      </div>
    </div>
  );
}
